const isAnswered = localAnswer => localAnswer === 'visited';
const getEvidenceText = questionData => questionData.get('evidenceText');
const getResumedAnswer = (blanksData) => blanksData.get('resumedAnswer');

export { isAnswered, getEvidenceText, getResumedAnswer };
